import { createSelector } from 'reselect';

import applicationPackagesSelector from './getApplicationPackagesSelector';

export default createSelector(applicationPackagesSelector, (packages) => packages?.length || 0);
